import { Injectable } from '@angular/core';
import { FormArray,FormControl } from '@angular/forms';
import { MatLegacyDialog } from '@angular/material/legacy-dialog';
import { firstValueFrom,Observable,Subject } from 'rxjs';
import {
    AccountsReceivableLedgerEntity,
    AccountsReceivableLedgerTypeEnum, AccountsReceivableLedgerTypePreventGlobalPreCharge,
    financialRound,
    isBookingPositionTypeEnum,
} from '../../../dave-data-module/entities/accounts-receivable-ledger.entity';
import { LedgerImportARLCalculationPreChargeByType } from '../../../dave-data-module/entities/ledger-import.entity';
import { arlBaseCostAllowanceType, ArlFormDataService, arlTableDataArlForm } from './arl-form-data.service';
import {
ArlAllowanceDialogComponent,
ArlAllowanceDialogComponentDialogData,
ArlAllowanceDialogComponentDialogReturnData
} from './arl-table/arl-allowance-dialog/arl-allowance-dialog.component';

import { Dictionary } from '@ngrx/entity';
import { Store } from '@ngrx/store';
import { MathScope } from 'mathjs';
import { ARLCustomProperties } from '../../../dave-data-module/entities/accounts-receivable-ledger-template.entity';
import { SurchargeRateEntity } from '../../../dave-data-module/entities/surcharge-rate.entity';
import { DaveMutationChangeAccountsReceivableLedgerArgs } from '../../../dave-data-module/graphql-types';
import { FrontendDate } from '../../../dave-data-module/helper/backend-frontend-conversion.helper';
import { getFetched$ } from '../../../dave-data-module/helper/helper';
import { ArlDataService } from '../../../dave-data-module/services/arl-data.service';
import { State } from '../../../dave-data-module/State';
import {
    getSurchargeRateDictionary,
    getSurchargeRateFetched,
    surChargeForArlType
} from '../../../dave-data-module/State/selectors/surcharge-rate.selector';
import * as mjsHelper from '../../../helper/math-js-helper';
import { ChangeTaxOption } from '../change-tax-dialog/change-tax-dialog.component';
import { SelectGaebArlDataTableItem } from '../select-gaeb-arl-data/select-gaeb-arl-data-table-datasource';
import {
ArlChargeByTypeDialogComponent,
ArlChargeByTypeDialogComponentDialogData,
ArlChargeByTypeDialogComponentDialogReturnData
} from './arl-table/arl-charge-by-type-dialog/arl-charge-by-type-dialog.component';
import {
ArlChargeDialogComponent,
ArlChargeDialogComponentDialogData,
ArlChargeDialogComponentDialogReturnData
} from './arl-table/arl-charge-dialog/arl-charge-dialog.component';
import { calculationArlFormGroup } from './calculation-arl-form-data.service';
import { QuantityTypeEntity } from '../../../dave-data-module/entities/quantity-type.entity';
import {
    getQuantityTypeDictionary,
    getQuantityTypesFetched,
} from '../../../dave-data-module/State/selectors/accounting.selector';
import { getParentsBaseCostAllowanceCharges } from './arl-calculation.helper';
import { isNullOrUndef } from 'chart.js/helpers';
import { isNullOrUndefined } from 'node:util';
import { isNotNullOrUndefined } from 'src/app/helper/helper';
import {
    ArlChargeOverrideDialogComponent,
    ArlChargeOverrideDialogComponentDialogData, ArlChargeOverrideDialogComponentDialogReturnData,
} from './arl-table/arl-charge-override-dialog/arl-charge-override-dialog.component';


@Injectable()
export class ArlTableService {
    private readonly defaultSurcharges$: Observable<Dictionary<SurchargeRateEntity>>;
    private readonly accountsReceivableLedgerDictionary$: Observable<Dictionary<AccountsReceivableLedgerEntity>>;
    private qTDict$:  Observable<Dictionary<QuantityTypeEntity>>;
    constructor(private dialog: MatLegacyDialog, private arlFormDataService: ArlFormDataService, private arlDataService: ArlDataService, store: Store<State>) {
        this.defaultSurcharges$ = getFetched$(store, getSurchargeRateFetched, getSurchargeRateDictionary);
        this.accountsReceivableLedgerDictionary$ = this.arlDataService.selectAllArlsDict();
        this.qTDict$ = store.select(getQuantityTypeDictionary);
    }

    openChargeByTypeDialog(data: ArlChargeByTypeDialogComponentDialogData) {
        return this.dialog.open<ArlChargeByTypeDialogComponent, ArlChargeByTypeDialogComponentDialogData, ArlChargeByTypeDialogComponentDialogReturnData>(ArlChargeByTypeDialogComponent, {
            ...ArlChargeByTypeDialogComponent.DefaultConfig,
            data,
        });
    }
    openChargeDialog(data: ArlChargeDialogComponentDialogData) {
        return this.dialog.open<ArlChargeDialogComponent, ArlChargeDialogComponentDialogData, ArlChargeDialogComponentDialogReturnData>(ArlChargeDialogComponent, {
            ...ArlChargeDialogComponent.DefaultConfig,
            data,
        });
    }
    openAllowanceDialog(data: ArlAllowanceDialogComponentDialogData) {
        return this.dialog.open<ArlAllowanceDialogComponent, ArlAllowanceDialogComponentDialogData, ArlAllowanceDialogComponentDialogReturnData>(ArlAllowanceDialogComponent, {
            ...ArlAllowanceDialogComponent.DefaultConfig,
            data,
        });
    }
    openChargeOverrideDialog(arlForm: arlTableDataArlForm, aRLCalculationPreCharge: number) {
        const dialogRef = this.dialog.open<ArlChargeOverrideDialogComponent, ArlChargeOverrideDialogComponentDialogData, ArlChargeOverrideDialogComponentDialogReturnData>(ArlChargeOverrideDialogComponent, {
            ...ArlChargeOverrideDialogComponent.DefaultConfig,
            data: {
                arlChargeFormArray: arlForm.controls.BaseCostAllowances,
            },
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'submitted') {
                this.resetSurchargeOverrides(arlForm, aRLCalculationPreCharge);
            }
        });
        return dialogRef;
    }

    private skipRecalculateBaseCost = false;
    public skipRecalculateSurcharge = false;

    async recalculateAllQuantitiesByUpdatedVariables(updatedVariables: string[], rootArlForms: arlTableDataArlForm[], maxDecimalPlaces: number, scope: MathScope) {
        const arlForms = await firstValueFrom(this.arlFormDataService.getChildren$(rootArlForms.map((f) => f.getRawValue().Id)));
        arlForms.forEach((form) => {
            if (isBookingPositionTypeEnum(form.getRawValue().Type)) {

                const recalc = (f: arlTableDataArlForm | calculationArlFormGroup) => {
                    if (f.controls.QuantityFormula.getRawValue() && f.controls.QuantityFormulaUsedVariables.getRawValue().some((v) => updatedVariables.includes(v))) {
                        const res = mjsHelper.evaluate(f.controls.QuantityFormula.getRawValue(), maxDecimalPlaces, scope);
                        if (!res.invalid && res.res !== f.controls.Quantity.getRawValue()) {
                            f.controls.Quantity.setValue(res.res);
                            f.controls.Quantity.markAsDirty();
                        }
                    }
                };

                if (!form.controls.UseQuantityHistory.getRawValue()) {
                    recalc(form);
                }

                const calcChildren = form.controls.childArlsCalculation.controls;
                calcChildren.forEach((child) => {
                    recalc(child);
                });
            }
        });
    }

    async recalculateAllBaseCost(
        rootArlForms: arlTableDataArlForm[],
        // preChargesByType: LedgerImportARLCalculationPreChargeByType[],
        // previousPreChargesByType: LedgerImportARLCalculationPreChargeByType[],
        globalPreCharge: number,
        previousGlobalPreCharge: number,
        skipARLsWithSurchargeOverride: boolean,
        skipARLsWithFrozenPrices: boolean,
    ) {
        // console.warn('recalculateAllBaseCost');
        // console.log({ preChargesByType, previousPreChargesByType, globalPreCharge, previousGlobalPreCharge });
        const arlForms = await firstValueFrom(this.arlFormDataService.getChildren$(rootArlForms.map((f) => f.controls.Id.getRawValue())));
        const defaultSurcharges = await firstValueFrom(this.defaultSurcharges$);
        const qTypes = await firstValueFrom(this.qTDict$);
        arlForms.forEach((form) => {
            if (skipARLsWithSurchargeOverride && isNotNullOrUndefined(form.controls.SurchargeOverride.getRawValue())) {
                return;
            } else if (skipARLsWithFrozenPrices && form.controls.FixedPrices.getRawValue()) {
                return;
            }
            if (isBookingPositionTypeEnum(form.controls.Type.getRawValue())) {
                const surchargePercentFormvalue = ArlTableService.getSurchargePercentFormValue(form.getRawValue(), /*previousPreChargesByType,*/ previousGlobalPreCharge, defaultSurcharges, qTypes);
                // const surchargePercentFormvalue = form.controls.sur
                this.skipRecalculateSurcharge = true;
                this.recalculateBaseCost(form, /*preChargesByType,*/ globalPreCharge, /*defaultSurcharges,*/ surchargePercentFormvalue, qTypes);
                this.skipRecalculateSurcharge = false;
            }
        });
    }

    /**
     * Use only for NOT LV Calculation ! in LV Calculation preChargesByType are used different
     * @param rootArlForms
     * @param preChargesByType
     * @param previousPreChargesByType
     * @param globalPreCharge
     * @param previousGlobalPreCharge
     */
    async recalculateCostAndBaseCostOnPreChargeChange(
        rootArlForms: arlTableDataArlForm[],
        preChargesByType: LedgerImportARLCalculationPreChargeByType[],
        previousPreChargesByType: LedgerImportARLCalculationPreChargeByType[],
        globalPreCharge: number,
        previousGlobalPreCharge: number,
    ) {
        // console.warn('recalculateAllCost');
        // console.log({ preChargesByType, previousPreChargesByType, globalPreCharge, previousGlobalPreCharge });
        const arlForms = await firstValueFrom(this.arlFormDataService.getChildren$(rootArlForms.map((f) => f.getRawValue().Id)));
        const defaultSurcharges = await firstValueFrom(this.defaultSurcharges$);
        const qTypes = await firstValueFrom(this.qTDict$);
        arlForms.forEach((form) => {
            if (isBookingPositionTypeEnum(form.controls.Type.getRawValue()) && !isNotNullOrUndefined(form.controls.SurchargeOverride.getRawValue()) && !form.controls.FixedPrices.getRawValue()) {
                const surchargePercentFormvalue = ArlTableService.getSurchargePercentFormValue(form.getRawValue(), /*previousPreChargesByType,*/ previousGlobalPreCharge, defaultSurcharges, qTypes);
                // const surchargePercentFormvalue = form.controls.sur
                this.skipRecalculateSurcharge = true;
                const pc = preChargesByType.find((p) => p.arlType === form.controls.Type.getRawValue());
                const ppc = previousPreChargesByType.find((p) => p.arlType === form.controls.Type.getRawValue());
                // console.log({pc,ppc})
                if (pc.percentage !== ppc.percentage) {
                    const originalCost = 1 + ppc.percentage ? form.controls.CostAmount.getRawValue() / (1 + ppc.percentage) : 0;
                    const newCost = originalCost * (1 + pc.percentage);
                    // console.log(newCost);
                    form.controls.CostAmount.setValue(financialRound(newCost, AccountsReceivableLedgerEntity.CostAmountDecimalPlaces + 2));
                }
                this.recalculateBaseCost(form, globalPreCharge, surchargePercentFormvalue, qTypes);
                this.skipRecalculateSurcharge = false;
            }
        });
    }

    async overrideAllSurcharge(
        rootArlForms: arlTableDataArlForm[],
        filter: { arlType: AccountsReceivableLedgerTypeEnum },
        surcharge: number,
        globalPreCharge: number,
    ) {
        const arlForms = rootArlForms.length ? await firstValueFrom(this.arlFormDataService.getChildren$(rootArlForms.map((f) => f.getRawValue().Id))) : [];
        // const defaultSurcharges = await firstValueFrom(this.defaultSurcharges$);
        const qTypes = await firstValueFrom(this.qTDict$);
        // console.warn('overrideAllSurcharge', surcharge);
        // const tabledata = await firstValueFrom(this.tableData$);
        arlForms.forEach((form) => {
            const type = form.controls.Type.getRawValue();

            if (isBookingPositionTypeEnum(type) && type === filter.arlType) {
                this.skipRecalculateSurcharge = true;
                this.recalculateBaseCost(form, /*preChargesByType,*/ globalPreCharge, /*defaultSurcharges,*/ surcharge, qTypes);
                this.skipRecalculateSurcharge = false;
            }
        });
    }

    async recalculateCost(form: arlTableDataArlForm,  globalPreCharge: number, surchargePercentFormvalue: number) {
        let percentFactor = 1 + (surchargePercentFormvalue || 0) / 100;

        // const typePreCharge = preChargesByType.find((c) => c.arlType === form.value.Type);
        //
        // if (typePreCharge?.percentage) {
        //     percentFactor = percentFactor * (1 + (typePreCharge.percentage * -1));
        // }

        let  hourQt = false
        if(form.controls?.QuantityTypeId.value){
            const qTdict = await firstValueFrom(this.qTDict$)
            hourQt =  qTdict[form.controls.QuantityTypeId.value].PreventGlobalPreCharge
        }
        if (globalPreCharge && !AccountsReceivableLedgerTypePreventGlobalPreCharge(form.value.Type) && !hourQt) {
            percentFactor = percentFactor * (1 + globalPreCharge);
        }

        const ek = percentFactor ? financialRound(form.controls.BaseCost.value / percentFactor) : 0;

        if ((form.value.CostAmount || 0) !== ek) {
            form.controls.CostAmount.setValue(ek);
            form.controls.CostAmount.markAsDirty();
        }
    }
    recalculateBaseCost(form: arlTableDataArlForm,/* preChargesByType: LedgerImportARLCalculationPreChargeByType[],*/ globalPreCharge: number, /*defaultSurcharges: Dictionary<SurchargeRateEntity>,*/ surchargePercentFormvalue: number, quantityTypes : Dictionary<QuantityTypeEntity>) {
        if (this.skipRecalculateBaseCost) {
            this.skipRecalculateBaseCost = false;
            return;
        }
        if (!form.value.CostAmount || form.value.InheritFromChildren) {
            return;
        }

        let  hourQt = false
        if(form.controls?.QuantityTypeId.value){
            hourQt =  quantityTypes[form.controls.QuantityTypeId.value].PreventGlobalPreCharge
        }

        let percentFactor: number;

        percentFactor = 1 + (surchargePercentFormvalue || 0) / 100;

        if (!form.controls.FixedPrices.getRawValue()) {
            const surchargeOverride = form.controls.SurchargeOverride.getRawValue();

            if (isNotNullOrUndefined(surchargeOverride)) {
                percentFactor = 1 + surchargeOverride / 100;
            } else {
                // const typePreCharge = preChargesByType.find((c) => c.arlType === form.value.Type);
                //
                // if (typePreCharge?.percentage) {
                //     percentFactor = percentFactor * (1 + (typePreCharge.percentage * -1));
                // }

                if (globalPreCharge && !AccountsReceivableLedgerTypePreventGlobalPreCharge(form.value.Type) && !hourQt) {
                    percentFactor = percentFactor * (1 + globalPreCharge);
                }
            }
        }


        const vk = (form.value.CostAmount || 0) * percentFactor;
        let salaryVK = (form.value.BaseCost ? (form.value.SalaryBaseCost || 0) / form.value.BaseCost : 0) * vk;
        if (!form.value.BaseCost && form.value.Type === AccountsReceivableLedgerTypeEnum.EmployeeArl && !hourQt) {
            salaryVK = vk;
        }
        this.skipRecalculateSurcharge = true;
        const newBaseCost = financialRound(vk);
        const oldBaseCost = form.value.BaseCost;

        const newSalaryBaseCost = financialRound(salaryVK);
        const oldSalaryBaseCost = form.value.SalaryBaseCost;

        const newBaseCostGross = financialRound(newBaseCost * (form.controls.Tax.value / 100 + 1));
        const oldBaseCostGross = form.value.BaseCostGross;

        const newSonstigesBaseCost = financialRound(newBaseCost - newSalaryBaseCost);

        if (oldBaseCost !== newBaseCost || oldSalaryBaseCost !== newSalaryBaseCost) {
            form.patchValue(
                {
                    BaseCost: newBaseCost,
                    BaseCostGross: newBaseCostGross,
                    SalaryBaseCost: newSalaryBaseCost,
                },
                { emitEvent: true },
            );
            if (oldBaseCost !== newBaseCost) {
                form.controls.BaseCost.markAsDirty();
            }
            if (oldSalaryBaseCost !== newSalaryBaseCost) {
                form.controls.SalaryBaseCost.markAsDirty();
            }
            if (oldBaseCostGross !== newBaseCostGross) {
                form.controls.BaseCostGross.markAsDirty();
            }
        }
        this.skipRecalculateSurcharge = true;
        if (newSonstigesBaseCost !== form.controls.sonstigesBaseCost.value) {
            form.controls.sonstigesBaseCost.setValue(newSonstigesBaseCost, { emitEvent: false });
            form.controls.sonstigesBaseCost.markAsDirty();
        }
        this.skipRecalculateSurcharge = false;
        // console.log({ vk, salaryVK, costAmount: form.value.CostAmount, percentFactor });
    }
    async recalculateSurcharge(form: arlTableDataArlForm, /*preChargesByType: LedgerImportARLCalculationPreChargeByType[],*/ globalPreCharge: number, surchargePercentForm?: FormControl<number>) {
        if (this.skipRecalculateSurcharge) {
            this.skipRecalculateSurcharge = false;
            return;
        }
        // console.warn('recalculateSurcharge');
        // const typePreCharge = preChargesByType.find((c) => c.arlType === form.value.Type);

        const vFixedPrices = form.controls.FixedPrices.getRawValue();
        const vSurchargeOverride = form.controls.SurchargeOverride.getRawValue();
        if (!vFixedPrices && isNotNullOrUndefined(vSurchargeOverride)) {
            // todo ggf form setzen,
            // this.skipRecalculateBaseCost = true;
            // if (vSurchargeOverride !== surchargePercentForm.value) {
            //     surchargePercentForm.setValue(vSurchargeOverride, { emitEvent: false });
            // }
            // this.skipRecalculateBaseCost = false;
            return;
        }

        const vCostAmount = form.controls.CostAmount.getRawValue();
        const vBaseCost = form.controls.BaseCost.getRawValue();

        if (vCostAmount && vBaseCost) {
            this.skipRecalculateBaseCost = true;
            let diff = 1 + ((vBaseCost || 0) / vCostAmount - 1);
            // if (typePreCharge?.percentage) {
            //     diff = diff / (1 + (typePreCharge.percentage * -1));
            // }
            if (!vFixedPrices) {
                let  hourQt = false
                if(form.controls?.QuantityTypeId.value){
                    const qTdict = await firstValueFrom(this.qTDict$)
                    hourQt =  qTdict[form.controls.QuantityTypeId.value].PreventGlobalPreCharge
                }
                if (globalPreCharge && !AccountsReceivableLedgerTypePreventGlobalPreCharge(form.value.Type) && !hourQt) {
                    diff = diff / (1 + globalPreCharge);
                }
            }
            if (surchargePercentForm) {
                const newValue = financialRound((diff - 1) * 100);
                if (newValue !== surchargePercentForm.value) {
                    surchargePercentForm.setValue(newValue, { emitEvent: false });
                }
            }
            this.skipRecalculateBaseCost = false;
        }
    }
    static  getSurchargePercentFormValue(
        e: { CostAmount: number | null; BaseCost: number | null; Type: AccountsReceivableLedgerTypeEnum; QuantityTypeId : number | null, FixedPrices: boolean },
        // preChargesByType: LedgerImportARLCalculationPreChargeByType[],
        globalPreCharge: number,
        defaultSurcharges: Dictionary<SurchargeRateEntity>,
        qTypeDictonary: Dictionary<QuantityTypeEntity>
    ) {
        // const typePreCharge = preChargesByType?.find((c) => c.arlType === e.Type);

        let diff = e.CostAmount ? (e.BaseCost || 0) / e.CostAmount : 0;
        // console.log('diff', diff);

        // if (typePreCharge?.percentage) {
        //     diff = diff / (1 + (typePreCharge.percentage * -1));
        //     console.log(diff, typePreCharge.percentage);
        // }
        if (!e.FixedPrices) {
            let  hourQt = false
            if(e.QuantityTypeId){
                const qtType = qTypeDictonary[e.QuantityTypeId];
                if (!qtType) {
                    console.log(`Quantity type with ID ${e.QuantityTypeId} not found in dictionary.`, qTypeDictonary);
                    throw new Error(`Quantity type with ID ${e.QuantityTypeId} not found in dictionary.`);
                }
                hourQt = qtType.PreventGlobalPreCharge;
            }

            if (globalPreCharge && !AccountsReceivableLedgerTypePreventGlobalPreCharge(e.Type) && !hourQt) {
                diff = diff / (1 + globalPreCharge);
                // console.log(diff, globalPreCharge);
            }
        }

        let surchargePercentFormValue = 0;
        if (e.BaseCost) {
            surchargePercentFormValue = financialRound((diff - 1) * 100);
        } else if (!e.CostAmount) {
            surchargePercentFormValue = surChargeForArlType(e.Type, defaultSurcharges)?.PercentageValue;
        }
        return surchargePercentFormValue;
    }
    /**
     *
     * @param tax in percent 19% => 19
     * @param arlIds root arls
     */
    async setAllTax(tax: number, arlIds: number[], changeType: ChangeTaxOption): Promise<void> {
        // firstValueFrom(this.tableData$).then((tableData) => {
        //     tableData.forEach(t => t.)
        //
        // })

        await firstValueFrom(this.accountsReceivableLedgerDictionary$).then((arls) => {
            arlIds
                .map((arlId) => this.arlFormDataService.getChildIds(arlId, true))
                .flat()
                .forEach((arlId) => {
                    let form = this.arlFormDataService.getForm(arlId);
                    if (!form) {
                        this.arlFormDataService.setFormByEntity(arls[arlId], arls);
                        form = this.arlFormDataService.getForm(arlId);
                    }
                    form.controls.Tax.setValue(tax);
                    form.controls.Tax.markAsDirty();
                    if (changeType === ChangeTaxOption.AdjustGross) {
                        form.controls.BaseCostGross.setValue(financialRound(form.controls.BaseCost.value * (form.controls.Tax.value / 100 + 1)));
                    } else if (changeType === ChangeTaxOption.AdjustNet) {
                        form.controls.BaseCost.setValue(financialRound(form.controls.BaseCostGross.value / (form.controls.Tax.value / 100 + 1)));
                        form.controls.SalaryBaseCost.setValue(financialRound(form.controls.BaseCostGross.value / (form.controls.Tax.value / 100 + 1)));
                    }
                });
        });
    }

    async updatePriceValuesInFormControl(rootArlIds: number[], preChargesByType: LedgerImportARLCalculationPreChargeByType[], globalPreCharge: number): Promise<void> {
        const arls = await firstValueFrom(this.accountsReceivableLedgerDictionary$);
        rootArlIds
            .map((arlId) => this.arlFormDataService.getChildIds(arlId, true))
            .flat()
            .forEach((arlId) => {
                const form = this.arlFormDataService.getForm(arlId);
                const selectedArl = arls[arlId];
                form.patchValue({
                    BaseCost: selectedArl.BaseCost,
                    Quantity: selectedArl.Quantity,
                    SalaryBaseCost: selectedArl.SalaryBaseCost,
                    CostAmount: selectedArl.CostAmount,
                });
            });
        // await this.recalculateAllSurcharge(
        //     rootArlIds.map((id) => this.arlFormDataService.getForm(id)),
        //     preChargesByType,
        //     globalPreCharge,
        // );
    }

    /**
     * calculation has to be already submitted
     * @param rootArlIds
     */
    async submitArls(rootArlIds: number[]): Promise<{ someWasChanged: boolean; arls: AccountsReceivableLedgerEntity[] }> {
        const arlForms = rootArlIds.length ? await firstValueFrom(this.arlFormDataService.getChildren$(rootArlIds)) : [];
        const arlsFromState = await firstValueFrom(this.accountsReceivableLedgerDictionary$);

        if (arlForms.length === 0) {
            return { someWasChanged: false, arls: [] };
        }
        const toChange: DaveMutationChangeAccountsReceivableLedgerArgs[] = [];
        const toReturn: AccountsReceivableLedgerEntity[] = [];
        arlForms.forEach((form) => {
            // fix dafür das es arls gibt bei denen die Parentid nicht null gesetzt wurde, da ein bug im Frontend war.
            // todo das kann raus wenn man das in der Datenbank repariert hat D277-5096
            const fromState = arlsFromState[form.getRawValue().Id];

            const wrongParentId = form.controls.ParentId.getRawValue() && rootArlIds?.includes(form.controls.Id.getRawValue());
            if (form.dirty || wrongParentId) {
                if (wrongParentId) {
                    console.error('arl wrong parent id', form.getRawValue().Id, form.controls.ParentId.getRawValue(), rootArlIds);
                    form.controls.ParentId.setValue(null);
                }

                toChange.push(getChangeMutationPayload(form, fromState?.CustomProperties, fromState?.Multiplier));
            } else {
                if (!fromState) {
                    console.error('arlNotFound', form.getRawValue().Id);
                }
                toReturn.push(fromState);
            }
        });
        const markAllPristine = () => {
            arlForms.forEach((form) => {
                if (form.dirty) {
                    form.markAsPristine(); // (dirty) fix bug, beim speichern klicken werden die groups dirty, die controls darin aber nicht
                }
            });
        };
        return toChange.length
            ? this.arlDataService.changeArls(toChange).then((changed) => {
                  markAllPristine();
                  return { someWasChanged: true, arls: [...changed, ...toReturn] };
              })
            : { someWasChanged: false, arls: toReturn };
    }
    public lvUpdate$ = new Subject<void>();
    updateLvPartieHEur(lvPartieHEur: number | null, rootArlIds: number[], isLvCalculated: boolean, preChargesByType: LedgerImportARLCalculationPreChargeByType[], globalPreCharge: number) {
        rootArlIds
            .map((arlId) => this.arlFormDataService.getChildIds(arlId, true))
            .flat()
            .forEach((arlId) => {
                let form = this.arlFormDataService.getForm(arlId);
                if (!form) {
                    console.error('updateLvPartieHEur: form not found. arlId: ' + arlId);
                }
                if (form.controls.lvCalculation.controls.PartieHEur.getRawValue() !== lvPartieHEur) {
                    form.controls.lvCalculation.controls.PartieHEur.setValue(lvPartieHEur, { emitEvent: false });
                    form.controls.lvCalculation.controls.PartieHEur.markAsDirty();
                }
            });

        if (isLvCalculated) {
            this.lvUpdate$.next();
        }
    }
    updatePriceLV(srcArlData: SelectGaebArlDataTableItem[], supplierId: number | null, form: FormArray<arlTableDataArlForm>) {
        const value = form.value;

        // todo BaseCostGross BaseCost SalaryBaseCost CostAmount setzen

        function setPrice(arlTableDataArlForm: arlTableDataArlForm['value']) {
            const match = srcArlData.find((d) => d.matchedArlId === arlTableDataArlForm.Id);
            if (match) {
                arlTableDataArlForm.SupplierId = supplierId;
                arlTableDataArlForm.lvCalculation.SoEk = match.price;
            }
            arlTableDataArlForm.childArls?.forEach((arl) => setPrice(arl));
        }
        value.forEach((value) => {
            setPrice(value);
        });
        // srcArlData.forEach((a) => {
        //     if (a.matchedArlId) {
        //         const arlForm = this.arlFormDataService.getForm(a.matchedArlId);
        //         const ekForm = arlForm?.controls.lvCalculation.controls.SoEk;
        //         const supplierForm = arlForm?.controls.SupplierId;
        //         if (!ekForm || !supplierForm) {
        //             throw new Error('ekForm or supplierForm not found, arlId: ' + a.matchedArlId);
        //         }
        //         if (supplierForm.getRawValue() !== supplierId) {
        //             // supplierForm.setValue(supplierId);
        //             supplierForm.markAsDirty();
        //         }
        //         if (ekForm.getRawValue() !== a.price) {
        //             // ekForm.setValue(a.price);
        //             ekForm.markAsDirty();
        //         }
        //     }
        // });
        form.patchValue(value);
    }
    async resetSurchargeOverrides(arlForm: arlTableDataArlForm, aRLCalculationPreCharge: number) {
        const ParentBaseCostAllowances = await firstValueFrom(this.arlFormDataService.parentBaseCostAllowances$(arlForm.controls.Id.getRawValue()));

        const qtTypes = await firstValueFrom(this.qTDict$)
        const allowanceCharges: Array<typeof arlForm.controls.BaseCostAllowances.value> = [arlForm.controls.BaseCostAllowances.value, ...ParentBaseCostAllowances];
        const overrideSurcharges: Map<AccountsReceivableLedgerTypeEnum, typeof arlForm.controls.BaseCostAllowances.value[0]> = new Map();

        allowanceCharges.flat().forEach((ac) => {
            if (ac.type === 'surchargeOverride' && !overrideSurcharges.has(ac.arlType)) {
                overrideSurcharges.set(ac.arlType, ac);
            }
        });

        const recursivFixes = (arlForm: arlTableDataArlForm, parentOverrideSurcharges: Map<AccountsReceivableLedgerTypeEnum, typeof arlForm.controls.BaseCostAllowances.value[0]>)=> {
            let _overrideSurcharges = new Map(parentOverrideSurcharges);

            arlForm.controls.BaseCostAllowances.getRawValue().forEach((ac) => {
                if (ac.type === 'surchargeOverride') {
                    _overrideSurcharges.set(ac.arlType, ac);
                }
            });
            let overrideSurcharge: number | null | undefined = _overrideSurcharges.get(arlForm.controls.Type.getRawValue())?.percent;
            this.resetSurchargeOverrideArl(arlForm, overrideSurcharge, aRLCalculationPreCharge, qtTypes);


            arlForm.controls.childArls.controls.forEach((arl) => {
                recursivFixes(arl, _overrideSurcharges);
            });
            arlForm.controls.childArlsCalculation.controls.forEach((arl) => {
                resetSurchargeOverrideCalculationArl(arl, _overrideSurcharges.get(arl.controls.Type.getRawValue())?.percent);
            });
        }
        recursivFixes(arlForm, overrideSurcharges);
    }
    public resetSurchargeOverrideArl(
        arlForm: arlTableDataArlForm,
        overrideSurcharge: number | null | undefined,
        aRLCalculationPreCharge: number,
        qtTypes: Dictionary<QuantityTypeEntity>) {
        if (!isNotNullOrUndefined(overrideSurcharge)) {
            overrideSurcharge = null;
        }
        if (overrideSurcharge !== arlForm.controls.SurchargeOverride.getRawValue() || overrideSurcharge) {
            if (overrideSurcharge !== arlForm.controls.SurchargeOverride.getRawValue()) {
                arlForm.controls.SurchargeOverride.markAsDirty();
                arlForm.controls.SurchargeOverride.setValue(overrideSurcharge);
            }
            if (!arlForm.controls.FixedPrices.getRawValue()) {
                this.recalculateBaseCost(arlForm, aRLCalculationPreCharge, overrideSurcharge, qtTypes);
            }
        }
    }
}
export function resetSurchargeOverrideCalculationArl(arl: calculationArlFormGroup, overrideSurcharge: number | null | undefined) {
    if (!isNotNullOrUndefined(overrideSurcharge)) {
        overrideSurcharge = null;
    }
    if (overrideSurcharge !== arl.controls.SurchargeOverride.getRawValue() || overrideSurcharge) {
        if (overrideSurcharge !== arl.controls.SurchargeOverride.getRawValue()) {
            arl.controls.SurchargeOverride.markAsDirty();
            arl.controls.SurchargeOverride.setValue(overrideSurcharge);
        }
        if (arl.controls.CostAmountAllowance.getRawValue()) {
            arl.controls.CostAmountAllowance.markAsDirty();
            arl.controls.CostAmountAllowance.setValue(null);
        }
        if (arl.controls.IndividuallyCostCalculation.getRawValue()) {
            arl.controls.IndividuallyCostCalculation.markAsDirty();
            arl.controls.IndividuallyCostCalculation.setValue(false);
        }
    }
}
const getChangeMutationPayload = (form:  arlTableDataArlForm, CustomProperties: ARLCustomProperties, multiplikator: number): DaveMutationChangeAccountsReceivableLedgerArgs => {
    const formValues = form.getRawValue();

    const additionalData: ARLCustomProperties = {
        ...CustomProperties,
        ZuschlaegeDefault: formValues.ZuschlaegeDefault,
        ZuschlaegeResourcen: formValues.ZuschlaegeResourcen,
        ZuschlaegeMaterials: formValues.ZuschlaegeMaterials,
        ZuschlaegeEmployee: formValues.ZuschlaegeEmployee,
        ZuschlaegeExternalService: formValues.ZuschlaegeExternalService,
        ZuschlaegeOther: formValues.ZuschlaegeOther,
    };
    return {
        id: formValues.Id,
        // amount: <- rechnet das Backend aus
        information: formValues.Information,
        bookingText: formValues.BookingText,
        baseCost: /*formValues.InheritFromChildren ? element.calculatedAmount.value : */ formValues.BaseCost || 0,
        baseCostGross: /*formValues.InheritFromChildren ? element.calculatedAmount.value : */ formValues.BaseCostGross || 0,
        costAmount: formValues.CostAmount || 0,
        quantity: formValues.Quantity || 0,
        quantityTypeId: formValues.QuantityTypeId,
        isVisible: true, //!formValues.InheritFromChildren || formValues.IsVisible,
        inheritFromChildren: formValues.InheritFromChildren,
        arlIds: formValues.ARLIds,
        parentId: formValues.ParentId,
        customProperties: JSON.stringify(additionalData),
        // type: formValues.Type,
        // todo add type wenn be ready
        tax: formValues.Tax,
        lohnBaseCostPart: formValues.SalaryBaseCost,

        multiplikator,
        showLongInformation: formValues.ShowLongtext || false,
        longInformation: formValues.Longtext,
        resourceId: formValues.ResourceId,
        materialId: formValues.MaterialId,
        isOptional: formValues.IsOptional,
        isCrossedOut: formValues.CrossedOut,
        jobSpecificationId: formValues.JobSpecificationId,
        // todo da die logik so funktioniert das das Frontend alle positionsnummern neu ausrechner wenn die  '' oder ' ' sind müssen die hier null gesetzt werden
        itemNumber: AccountsReceivableLedgerEntity.autogenerateItemNumbers.includes(formValues.ItemNumber) ? null : formValues.ItemNumber,
        hideInGroupSummary: formValues.HideInGroupSummary,
        supplierId: formValues.SupplierId,
        startOnNewPage: !!formValues.StartOnNewPage,
        baseCostAllowances: formValues.BaseCostAllowances?.map((b) => ({
            title: b.title,
            percent: b.percent,
            type: b.arlType,
        })),

        useQuantityHistory: formValues.UseQuantityHistory,
        showQuantityHistory: formValues.ShowQuantityHistory,
        quantityHistories: formValues.QuantityHistory ? formValues.QuantityHistory.map(h => ({date: h.date ? FrontendDate(h.date.toDate()) : null, quantityDelta: h.quantityDelta, quantityDeltaFormula: h.quantityDeltaFormula})) : [],
        lVFlEk: formValues.lvCalculation.FlEk,
        lVGEK: formValues.lvCalculation.GEK,
        lVMinutes: formValues.lvCalculation.minutes,
        lVSoAntEk: formValues.lvCalculation.SoAntEk,
        lVSoEk: formValues.lvCalculation.SoEk,
        lvPartieHEur: formValues.lvCalculation.PartieHEur,
        lvSoEkRabatt: formValues.lvCalculation.SoEkRabatt,
        quantityFormula: formValues.QuantityFormula,
        changedAfterSelectedFromPriceComparison: formValues.ChangedAfterSelectedFromPriceComparison,
        priceComparisonId: formValues.PriceComparisonId,
        gapPatches: formValues.Gaps?.map((g) => ({
            id: g.id,
            caption: g.caption,
            body: g.body,
            indexInLongText: g.indexInLongText,
        })),
        surchargeOverride: isNotNullOrUndefined(formValues.SurchargeOverride) ? formValues.SurchargeOverride : null,
        fixedPrices: formValues.FixedPrices,
        type: formValues.Type,
    };
}
